import type { HomePageData } from "../../services/HomeService";
import { hasFourPillarsData } from "../../utils/fourPillarsMapper";
import { cn } from "../../lib/utils";
import { Card } from "../ui/card";
import HomeBbsScoreSection from "./HomeBbsScoreSection";
import FourPillarsSection from "./FourPillarsSection";
import MedicalDisclaimerNotice from "../MedicalDisclaimerNotice";

export interface HomeBbsPillarsSummaryProps {
  homeData?: HomePageData;
  selectedDate?: string;
  showFourPillars?: boolean;
  className?: string;
}

const HomeBbsPillarsSummary = ({
  homeData,
  selectedDate,
  showFourPillars,
  className,
}: HomeBbsPillarsSummaryProps) => {
  const showBbs = homeData?.["Bite Balance Score"]?.daily_bbs != null;
  const pillars = homeData?.["4_pillars"];
  const showPillars =
    showFourPillars ?? (Boolean(pillars) && hasFourPillarsData(pillars));

  if (!showBbs && !showPillars) return null;

  const dateForBbs = selectedDate ?? new Date().toISOString().slice(0, 10);
  const combineBbsAndPillars = showBbs && showPillars && pillars;

  return (
    <div className={cn("space-y-2", className)}>
      {combineBbsAndPillars ? (
        <Card className="relative overflow-hidden rounded-2xl border border-border/80 bg-card shadow-sm dark:border-border/60">
          <div
            className="pointer-events-none absolute inset-x-0 top-0 h-10 bg-gradient-to-b from-[#737DFE]/[0.07] to-transparent dark:from-[#737DFE]/[0.12]"
            aria-hidden
          />
          <HomeBbsScoreSection
            homeData={homeData}
            selectedDate={dateForBbs}
            embedded
          />
          <div className="mx-4 border-t border-border/60" />
          <FourPillarsSection pillars={pillars} embedded />
        </Card>
      ) : (
        <>
          {showBbs ? (
            <HomeBbsScoreSection
              homeData={homeData}
              selectedDate={dateForBbs}
            />
          ) : null}
          {showPillars && pillars ? (
            <FourPillarsSection pillars={pillars} />
          ) : null}
        </>
      )}
      <MedicalDisclaimerNotice />
    </div>
  );
};

export default HomeBbsPillarsSummary;
